import { Stack } from '@chakra-ui/react';
import { createFieldHelper, FormContainer, renderFieldHelperInput, useHookForm } from '@cks-internal/react-base';
import { ApiEndpoints } from '../../../../constants/endpoints/apiEndpoints.ts';
import { ActivityInformationCompanyDisplay } from '../displays/activityInformationCompanyDisplay';
import { useWatch } from 'react-hook-form';
/**
 * CompanySearch component renders a company selector and displays selected company details.
 *
 * It uses `useHookForm` with a single numeric field `CompanyId` and
 * renders `ActivityInformationCompanyDisplay` when a company is chosen.
 *
 * @component
 * @returns {JSX.Element} A stack containing a company selector and company detail card.
 */

export const CompanySearch = () => {
  const { formMethods } = useHookForm<{ CompanyId: number | undefined }>({ CompanyId: undefined });
  const companyId = useWatch({
    control: formMethods.control,
    name: 'CompanyId'
  });
  const helper = createFieldHelper<{ CompanyId: number | undefined }>(formMethods);
  const fields = [
    helper
      .selectInputQueryItems('CompanyId', { searchUrl: ApiEndpoints.selectOptions.companies.list(false) })
      .withInputProps({ isClearable: true })
      .isNumeric()
  ];

  return (
    <Stack>
      <FormContainer methods={formMethods} onSubmit={() => {}} hideControls={true}>
        {renderFieldHelperInput('CompanyId', fields)}
      </FormContainer>
      {companyId && <ActivityInformationCompanyDisplay companyId={companyId} />}
    </Stack>
  );
};
